import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class MoreInfo extends Component {

  constructor() {
    super();

    this.clickHandler = this.clickHandler.bind(this);
  }

  /* Handlers */

  clickHandler(e) {
    e.stopPropagation();
    this.props.appModalOpen({
      component: this.props.content,
      title: this.props.intl.messages['advisory.detail.moreInfo'],
    });
  }

  /* Render */

  render() {
    return (
      <span role="button" onClick={this.clickHandler} className="more-info">
        <span className="more-info__content">
          {'i'}
        </span>
      </span>
    );
  }
}

MoreInfo.propTypes = {
  appModalOpen: PropTypes.func,
  intl: PropTypes.object,
  content: PropTypes.element,
};



// WEBPACK FOOTER //
// ./js/components/more-info/index.jsx